<template>
  <fragment>
    <template v-if="isNotAreaText">{{ value }}</template>
    <a v-else-if="isInvalidValue" class="link_modal" @click.prevent="onClickBlank">{{ value }}</a>
    <router-link v-else :to="`/stats/v2/user?area=${value}`" class="link_modal">{{ value }}</router-link>
  </fragment>
</template>

<script>
import {mapState} from 'vuex';
import {find} from 'lodash';
/*
소식톡톡 두뇌톡톡/기억검사 건강백세 통계에서 쓰이는 "지역선택된 상태로 대상자별통계로 이동시키는 버튼"
city까지만 입력되고, 지역선택 셀렉트박스에서 선택되지 못하는 상황에서는 alert을 띄우고,
지역형식이 아니면 일반텍스트로 뿌린다.
props value는 지역 id가 아닌 name으로 넘어오게 한다.
예) LH 서울특별시 금천구
http://jira.skplanet.com/browse/NUGUBTOB-477
*/
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['groupData']),
    valueArr() {
      return this.value.split(' ');
    },
    orgItem() {
      return find(this.groupData, (item) => item.orgName === this.valueArr[0]);
    },
    stateItem() {
      if (!this.orgItem) return null;
      return find(this.orgItem.states, (item) => item.stateName === this.valueArr[1]);
    },
    cityItem() {
      if (!this.stateItem) return null;
      return find(this.stateItem.cities, (item) => item.cityName === this.valueArr[2]);
    },
    isNotAreaText() {
      return this.valueArr.length < 3 || !this.orgItem;
    },
    isInvalidValue() {
      // org, state, city 까지 3개가 입력되어야 한다.
      // groupData에 3가지 모두가 존재해야 한다.
      return this.isNotAreaText || !this.stateItem || !this.cityItem;
    },
  },
  methods: {
    onClickBlank() {
      alert('지금은 없는 지역입니다.\n대상자 정보 메뉴에서 지역을 다시 설정해 주세요.');
    },
  },
};
</script>

<style></style>
